import { Dialog, DialogContent, DialogTitle, DropSelect } from '@zawarski/eti-ui';
import { X } from 'lucide-react';
import { HeaderComponent, IconButton } from '@components/rep';

/**
 * Legacy dashboard ChangeYearDialog: a small dialog with the blue
 * "Select Year" header and a standard Select of the available years.
 * Inline styles on the content: eti-ui's sm:max-w-lg and other variant classes outrank rep: ones.
 */
const ChangeYearDialog = ({
  open,
  onClose,
  years,
  value,
  onChange,
}: {
  open: boolean;
  onClose: () => void;
  years: string[];
  value?: string;
  onChange: (year: string) => void;
}) => (
  <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
    <DialogContent
      showCloseButton={false}
      aria-describedby={undefined}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0,
        width: 288,
        minHeight: 150,
        padding: 0,
        overflow: 'hidden',
        borderRadius: 4,
      }}>
      <HeaderComponent
        title={<DialogTitle style={{ font: 'inherit', color: 'inherit' }}>Select Year</DialogTitle>}
        icon={
          <IconButton aria-label='close' onDark onClick={onClose}>
            <X className='rep:text-white' />
          </IconButton>
        }
      />
      <div style={{ padding: '12px 16px' }}>
        <DropSelect
          fullWidth
          showClearButton={false}
          label='Select Year'
          placeholder='Select Year'
          options={years.map((year) => ({ label: year, value: year }))}
          value={value}
          onChange={(year) => {
            onChange(String(year));
            onClose();
          }}
        />
      </div>
    </DialogContent>
  </Dialog>
);

export default ChangeYearDialog;
